import React, { type FunctionComponent, Fragment } from 'react'
import AisleVisibilityModal from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityModal'
import AisleVisibilityWarningModal from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityWarningModal'

export interface AisleVisibilityModalProps {
  isModalOpen: boolean
  aisleName: string
  isAisleVisible: boolean
  setAisleVisibility: () => void
  handleCloseModal: () => void
}

interface Props extends AisleVisibilityModalProps {
  hasPrimaryProducts: boolean
}

const AisleVisibilityModals: FunctionComponent<Props> = ({
  isModalOpen,
  hasPrimaryProducts,
  aisleName,
  isAisleVisible,
  setAisleVisibility,
  handleCloseModal,
}) => {
  // Products whose primary aisle is hidden will not appear in store front,
  // the warning modal short circuits a potentially destructive action
  const shouldShowWarningModal = hasPrimaryProducts && isAisleVisible

  if (!isModalOpen) return null

  return (
    <Fragment>
      {shouldShowWarningModal ? (
        <AisleVisibilityWarningModal aisleName={aisleName} onClose={handleCloseModal} />
      ) : (
        <AisleVisibilityModal
          aisleName={aisleName}
          isAisleVisible={isAisleVisible}
          setAisleVisibility={setAisleVisibility}
          onClose={handleCloseModal}
        />
      )}
    </Fragment>
  )
}

export default AisleVisibilityModals
